import React from 'react';
import { isEmpty } from 'lodash';
import { pure } from 'recompose';
import { Tabs, Tab } from 'angieslist-react-components';
import { Showcase } from '../../common/profileService';
import ShowcaseDraftTab from './ShowcaseDraftTab';
import { defaultProps } from '../../../../app/browser/analyticsDefaultProperties';
import './ShowcaseGrid.scss';
import ShowcaseAdvertiserPublishedTab from './ShowcaseAdvertiserPublishedTab';
import ShowcaseNonAdPublishedTab from './ShowcaseNonAdPublishedTab';

type Props = {
  showcases: Showcase[],
  serviceProviderId: string | number,
  archiveShowcase: (showcaseId: number, serviceProviderId: string | number) => void,
  showcasePendingRemoval?: boolean,
  sendEnhancedAnalyticsEvent: (rule: any) => void,
  saveShowcaseOrder: any,
  userId: string,
  advertiseRequest: () => void,
  advertiseRequestPending: boolean,
  advertiseRequestSuccessful: boolean,
  isAdvertiser: Boolean,
  isNorthStar: boolean,
  serviceProviderUpgradeState: string,
};

class ShowcaseGrid extends React.Component {
  constructor(props) {
    super(props);
    const publishedShowcases = props.showcases.filter(showcase => showcase.showcaseStatus === 'Published');
    this.state = isEmpty(publishedShowcases) ? { tabKey: 'DraftsTab' } : { tabKey: 'PublishedTab' };
    this.switchTab = this.switchTab.bind(this);
  }

  switchTab(tabKey) {
    this.setState({ tabKey });
    this.props.sendEnhancedAnalyticsEvent({
      name: 'Item Clicked',
      properties: {
        ...defaultProps,
        description: tabKey === 'PublishedTab' ? 'Published Showcase Tab' : 'Draft Showcase Tab',
        activityLocation: tabKey === 'PublishedTab' ? 'SP : My Business : Showcase Drafts' : 'SP : My Business : Showcase Published',
      },
    });
  }

  props: Props;

  render() {
    const {
      showcases,
      serviceProviderId,
      archiveShowcase,
      showcasePendingRemoval,
      saveShowcaseOrder,
      userId,
      advertiseRequest,
      advertiseRequestPending,
      advertiseRequestSuccessful,
      isAdvertiser,
      isNorthStar,
      sendEnhancedAnalyticsEvent,
      serviceProviderUpgradeState,
    } = this.props;

    const publishedShowcases = showcases.filter(showcase => showcase.showcaseStatus === 'Published');
    const draftShowcases = showcases.filter(showcase => showcase.showcaseStatus === 'Draft');
    const shouldHideEdit = isNorthStar && !isAdvertiser;
    return (
      <Tabs
        id="showcase-tabs"
        className="showcase-tabs"
        activeKey={this.state.tabKey}
        onSelect={key => this.switchTab(key)}
      >
        <Tab eventKey="PublishedTab" title="Published">
          <Choose>
            <When condition={isNorthStar && !isAdvertiser}>
              <ShowcaseNonAdPublishedTab
                {...{
                  publishedShowcases,
                  serviceProviderId,
                  archiveShowcase,
                  showcasePendingRemoval,
                  advertiseRequest,
                  advertiseRequestPending,
                  advertiseRequestSuccessful,
                  sendEnhancedAnalyticsEvent,
                  serviceProviderUpgradeState,
                }}
                switchTab={() => this.switchTab('DraftTab')}
              />
            </When>
            <Otherwise>
              <ShowcaseAdvertiserPublishedTab
                {...{
                  publishedShowcases,
                  serviceProviderId,
                  archiveShowcase,
                  showcasePendingRemoval,
                  saveShowcaseOrder,
                  userId,
                  shouldHideEdit,
                  serviceProviderUpgradeState,
                }}
                switchTab={() => this.switchTab('DraftTab')}
              />
            </Otherwise>
          </Choose>
        </Tab>
        <Tab eventKey="DraftsTab" title="Drafts">
          <ShowcaseDraftTab
            {...{
              draftShowcases,
              serviceProviderId,
              archiveShowcase,
              showcasePendingRemoval,
              isAdvertiser,
              isNorthStar,
            }}
            switchTab={() => this.switchTab('PublishedTab')}
            draftShowcases={draftShowcases}
          />
        </Tab>
      </Tabs>
    );
  }
}

export default pure(ShowcaseGrid);



// WEBPACK FOOTER //
// ./src/modules/profile/browser/components/ShowcaseGrid.js